import { combineReducers } from 'redux';
import FooterContentReducer from './footerContent/reducers';


const HomepageContentReducers = combineReducers({
    footerContent: FooterContentReducer,
});

export default HomepageContentReducers;